var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaodi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 589",
    d: "M3.65625 11.0312L4.40625 13.6875H12.1875L12.75 10.25L15.3125 6.4375L13.75 6.8125L11.375 8.375L11.875 7L14.4688 4.21875L11.5312 5.71875L8.9375 7.8125L9.5625 5.875L11.5312 2.4375L8.9375 4.65625L7.5 6.8125L6.5625 5.875L3.125 3.09375L5.0625 5.875L6.125 8.375L5.59375 9.65625L3.375 7.96875L1.5 7.625L2.34375 8.65625L3.65625 11.0312Z",
    fill: "#118F34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 585",
    d: "M4.06435 13.6055C4.15417 13.1307 4.10285 11.75 3.17894 10.0253C2.25503 8.30072 1.02315 7.35628 0.522705 7.09964C2.08821 7.26646 5.80437 8.58559 8.14494 12.5276",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 586",
    d: "M5.46954 9.31324L6.08548 8.52407C5.71977 7.2152 4.36856 4.15091 1.8894 2.36469C4.24408 3.32067 9.30376 6.83409 10.705 13.2398",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 587",
    d: "M7.50977 6.63773C8.02946 5.60475 9.68865 3.27701 12.1678 2.22992C10.9295 3.3014 9.56931 5.02089 8.89563 8.11983C10.243 6.63773 12.3988 4.75142 14.6316 4.11623C13.7269 4.87974 11.5904 6.63773 11.3401 8.4278",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 588",
    d: "M10.4355 9.35172C11.2504 8.47914 13.3728 6.66854 15.3438 6.40677C14.2018 7.2986 11.9484 10.0408 12.0716 13.875",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaodi);
export default __webpack_public_path__ + "static/media/caodi.7b50ef8635ffcc118c5aab186b75155a.svg";
export { ForwardRef as ReactComponent };